import * as React from 'react';

const IconClose = () => (
    <svg viewBox="0 0 100 100">
        <polygon
            points="85,21.803 78.197,15 50,43.197 21.803,15 15,21.803 43.197,50
            15,78.197 21.803,85 50,56.803 78.197,85 85,78.197 56.803,50 "/>
    </svg>

);

export default IconClose;